import React, { memo } from "react";
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SidebarBoxContainer from "../SidebarBoxContainer";
import CollectionsIcon from "@mui/icons-material/Collections";
import { grey } from "@mui/material/colors";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import uuidToHash from '../utils/uuid-to-hash';
var theme = createTheme();
var useStyles = makeStyles(function (theme) {
  return {
    img: {
      width: 40,
      height: 40,
      borderRadius: 8
    }
  };
});
export var GroupSelectorSidebarBox = function GroupSelectorSidebarBox(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      groups = _ref.groups,
      onSelect = _ref.onSelect,
      selectedGroupId = _ref.selectedGroupId;
  var classes = useStyles();
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SidebarBoxContainer, {
    title: title || '',
    subTitle: subtitle || '',
    icon: React.createElement(CollectionsIcon, {
      style: {
        color: grey[700]
      }
    })
  }, React.createElement(List, null, groups.map(function (_ref2, i) {
    var id = _ref2.id,
        groupTitle = _ref2.title,
        groupSubtitle = _ref2.subtitle,
        color = _ref2.color;
    return React.createElement(ListItem, {
      button: true,
      onClick: function onClick() {
        return onSelect(id);
      },
      dense: true,
      key: id,
      style: {
        backgroundColor: id === selectedGroupId ? '#bbdefb' : null
      }
    }, React.createElement(ListItemText, {
      primary: React.createElement("strong", {
        style: {
          color: color
        }
      }, uuidToHash(groupTitle)),
      secondary: groupSubtitle
    }));
  }))));
};
export default GroupSelectorSidebarBox;